import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import Chip from 'aegisv2/Chip';
import Paper from 'aegisv2/Paper';
import T from 'aegisv2/Text';

import InverseButton from 'aegisv2/Buttons/InverseButton';
import { blue } from 'aegisv2/styles/colors';

const ScPaper = styled(Paper)`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  z-index: 0;
`;
const ScImage = styled.div`
  position: absolute;
  border-radius: 5px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: ${blue};
  background-size: cover;
  background-position: center;
  background-image: url(${props =>
    props.img.imgUrlMobile ? props.img.imgUrlMobile : props.img.defaultBlur});

  @media (min-width: 768px) {
    background-position: right;
    background-image: url(${props =>
      props.img.imgUrlPc ? props.img.imgUrlPc : props.img.defaultBlur});
  }
`;

const ScBody = styled.div`
  position: absolute;
  padding: 38px 18px;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  text-align: center;
  @media (min-width: 768px) {
    padding: 32px 29px;
    top: 0;
    text-align: left;
  }
  @media (min-width: 1280px) {
    padding: 36px;
  }
`;
const ScDescription = styled.p`
  display: none;
  color: #ffffff;
  font: 14px dinpro-light;
  line-height: 24px;
  letter-spacing: -0.49px;

  @media (min-width: 768px) {
    display: block;
    width: 70%;
  }
`;
const ScTitle = styled(T)`
  display: block;
`;
const ScChip = styled(Chip)`
  margin-bottom: 4px;
`;
const ScInverseButton = styled(InverseButton)`
  display: none;
  padding: 4px 21px;
  margin-top: 14px !important;
  span {
    font-size: 14px;
  }

  @media (min-width: 768px) {
    display: block;
    margin-top: 28px;
  }
`;
const defaultBlur =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAIAAAAPE8H1AAAAPUlEQVQIHQEyAM3/Adve7fn/AwD//AHi3ej5BQvm6OcBubnJ/fbqoqSgAbKrsunf1ZKjqwGyl5G5x8qqt7093yDTiccnmAAAAABJRU5ErkJggg==';

const CareerCard = ({
  className,
  title,
  description,
  courses,
  url,
  imgUrlMobile,
  imgUrlPc,
  onClick,
}) => {
  const imgUrl = { imgUrlMobile, imgUrlPc, defaultBlur };
  const Card = (
    <ScPaper className={classNames(className)} clickable noScale>
      <ScImage img={imgUrl} />
      <ScBody>
        <ScChip premium />
        <ScTitle s bold white>
          {title}
        </ScTitle>
        <ScTitle xs bold white>{`${courses} cursos`}</ScTitle>
        <ScDescription>{description}</ScDescription>
        <ScInverseButton label={'Explora más'} onClick={onClick} />
      </ScBody>
    </ScPaper>
  );

  if (onClick) {
    return <div onClick={onClick}>{Card}</div>;
  }
  return <a href={url}>{Card}</a>;
};

CareerCard.propTypes = {
  className: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  courses: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  imgUrlMobile: PropTypes.string.isRequired,
  imgUrlPc: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  description: PropTypes.string,
};

CareerCard.defaultProps = {
  onClick: undefined,
  description: '',
};

CareerCard.defaultProps = {
  className: '',
};

export default CareerCard;
